import { useEffect } from 'react';

import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import {
  getFileByTask,
  getFileDownloadingConfig,
  getPendingTasks,
} from 'utils/filesDownloaders/downloadingTaskManager';

import { showSnackbar } from './useSnackbar';

export function usePendingFilesDownloading() {
  useEffect(() => {
    const pendingTasks = getPendingTasks();

    if (pendingTasks.length > 0) {
      for (let task of pendingTasks) {
        try {
          getFileByTask(getFileDownloadingConfig(task), task);
        } catch (e) {
          window.console.log('Error occurred:', e);

          showSnackbar({
            text: `Generating "${task.title}.${task.extension}" error. Please, try again.`,
            type: SNACKBAR_SKIN.ERROR,
          });
        }
      }
    }
  }, []);
}
